import { useState } from "react";

import { Grid, useTheme } from "@mui/material";
import { LoadingButton } from '@mui/lab';
import { RepaymentInsert } from "store/api/repay";
import http from "config/http";
import { useFormContext } from "react-hook-form";
import { useMemo } from "react";
import useNotify from "hooks/useNotify";
import { actionButtonBg } from "utils/helpers/actionButtonBg";
import SuccessModal from "components/SuccessModal";

function RepaySubmit({ onClose }) {
  const notify = useNotify();
  const theme = useTheme()
  
  const { handleSubmit, watch, reset } = useFormContext();
  const amount = watch("amount");
  
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false)
  const [loading, setLoading] = useState(false)

  const isButtonDisabled = useMemo(() => !amount, [amount]);

  const onSubmit = async (data) => {
    try {
      setLoading(true)

      await http.post(RepaymentInsert, data);

      setOpenConfirmationModal(true)
    } catch (e) {
      notify(e?.response?.data?.message, "error");
    }

    setLoading(false)
  };

  return (
    <Grid item xs={12}>
      <LoadingButton
        disabled={isButtonDisabled}
        fullWidth
        variant="contained"
        loading={loading}
        color={actionButtonBg(theme)}
        onClick={handleSubmit(onSubmit)}
      >
        تایید
      </LoadingButton>

      {openConfirmationModal &&
        <SuccessModal
          title={"Repayment Successful"}
          subtitle={"Your repayment has been processed. Your margin wallet balance is now updated."}
          open={openConfirmationModal}
          onClose={() => {
            reset();
            setOpenConfirmationModal(false)
            onClose()
          }}
        />
      }
    </Grid>
  );
}

export default RepaySubmit;
